import {useMemo} from 'react'
import {useFilterContext} from '~/components'

const COORDINATE_PRECISION = 5 // Round to 5 decimal places (~1m at equator, ~0.7m in Amsterdam) to group nearby environments

export const useGroupedEnvironments = () => {
	const {items} = useFilterContext()

	return useMemo(() => {
		const roundedKey = ({lat, lng}) => `${Number(lat).toFixed(COORDINATE_PRECISION)},${Number(lng).toFixed(COORDINATE_PRECISION)}`

		const grouped = _.groupBy(items, roundedKey)

		return _.map(grouped, (environments, roundedKey) => {
			const [lat, lng] = roundedKey.split(',').map(Number)
			const statuses = _.uniq(environments._map('status'))
			const status = statuses.length > 1 ? 'mixed' : statuses[0]
			return {lat, lng, status, environments}
		})
	}, [items])
}
